import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Message, Room } from '../../models';
import { ApiConectateService } from '../../api/apiConectate';
import { Subject, Observable, of } from 'rxjs';
import { delay, take, takeUntil, tap } from 'rxjs/operators';
import { ApiChatMessagesService } from '../../api/apiChatMessages';
import { EVENTS_CONSTANTS } from '../../constants/events.constants';
import { IModalData } from './services/videoconference-main-modal.model';
import { VideoconferenceMainModalService } from './services/videoconference-main-modal.service';
import { ApiTunningService } from '../../api/apiTunning';
import { TestQualityService } from './components/publisher/services/test-quality-services/test-quality.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TooltipSupportService } from '../../services/tooltip-support/tooltip-support.service';
import { VIDEOCONFERENCE_CONSTANTS } from '../../constants/videoconference.constants';
import { ApiTokboxService } from '../../api/apiTokbox';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { StateHandlerService } from '../../services/state-handler/state-handler.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { ParticipantsService } from '../../services/participants/participants.service';
import { HeaderService } from '../../services/header/header.service';
import { UtilsService } from '../../services/utils/utils.service';
import { ROUTES_CONSTANTS } from '../../constants/routes.constants';
import { SupportTooltipComponent } from '../../components/support-tooltip/support-tooltip.component';
import { ParticipantsTooltipComponent } from './components/participants-tooltip/participants-tooltip.component';
import { ChatComponent } from './components/chat/chat.component';
import { AsyncPipe, JsonPipe, NgClass } from '@angular/common';
import { ScreenShareComponent } from './components/screen-share/screen-share.component';
import { SubscriberComponent } from './components/subscriber/subscriber.component';
import { PublisherComponent } from './components/publisher/publisher.component';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'sas-videoconference-main',
  standalone: true,
  imports: [
    TranslatePipe,
    SupportTooltipComponent,
    ParticipantsTooltipComponent,
    ChatComponent,
    NgClass,
    ScreenShareComponent,
    SubscriberComponent,
    PublisherComponent,
    AsyncPipe
    
  ],
  styleUrls: ['./videoconference-main.component.scss'],
  templateUrl: './videoconference-main.component.html',
})
export class VideoconferenceMainComponent implements OnInit, OnDestroy {
  public chatMessages?: boolean;
  public session!: OT.Session;
  public streams: Array<any> = [];
  public messageToSend = '';
  public roomData?: Room;
  public fullScreen = false;
  public fullScreenPublisher = false;
  public subscriberAudio = true;
  public openChat: boolean = false;
  public fullDesktopPublisher = false;
  public streamScreenShare?: OT.Stream;
  public screenShareFrame = false;
  public openUsers = false;
  public showTooltipList = false;
  public showIconUser = true;
  public participantsData: any;
  public features;
  public setTimeoutId: any;
  public openCloseTooltipSupport$?: Observable<boolean>;
  public showLostSignalModal$: Observable<boolean> = of(false);

  /**
   * Datos para apertura del modal
   */
  public showModal$?: Observable<IModalData>;
  public storedChatMessages: any;
  public forcePublish = false;

  private events = EVENTS_CONSTANTS;
  private videoConstants = VIDEOCONFERENCE_CONSTANTS;
  private MAX_PARTICIPANTS_COMPLETESCREEN = 2;
  private publisher?: OT.Publisher;
  private enableDDBBStorage = false;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private bandwidthModalErrorEnable = true;
  private bandwidthModalErrorTimeout: any;
  private bandwidthModalInterval: any;

  public isConnect = false;
  /**
   * Método que abre el supportNumberTooltip.
   */
  public showSupportNumber() {
    this.tooltipSupportService.setCloseOpenTooltipSupport(true);
  }


  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly apiTokBoxSvc: ApiTokboxService,
    private readonly apiConectateServ: ApiConectateService,
    private readonly participantsSvc: ParticipantsService,
    private readonly headerSvc: HeaderService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly router: Router,
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly enviromentSvc: EnvironmentService,
    private readonly apiChatMessagesService: ApiChatMessagesService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly utilsService: UtilsService,
    private readonly videoconferenceMainModalService: VideoconferenceMainModalService,
    private readonly apiTunningService: ApiTunningService,
    private readonly testQualityService: TestQualityService,
    private readonly tooltipSupportService: TooltipSupportService
  ) {
    this.features = this.enviromentSvc.data.features;
    this.enableDDBBStorage =
      this.enviromentSvc.data?.features?.enable_bbdd_storage;
    this.bandwidthModalInterval =
      this.enviromentSvc.data?.someParams?.bandwidthModalInterval ?? 30000;
  }
  /**
   * Se inicializa el compoenente de videoconferencia:
   * - Si está habilitada la opción de mensajes en BBDD en el config.json se obtienen los mensajes guardados.
   * - Se inicializa el modal
   * - Se inicializa el BehaviorSubject forceTestStopBS de testQualityService a falso
   */
  async ngOnInit() {
    this.isConnect = false;
    if(environment.isPatient){
      this.stateHandlerSvc.set("goToSurvey", false);
      this.sessionStorageSrv.set('s', null);
    }
    this.testQualityService.forceTestStopBS.next(false);
    console.log('ENTER TO VIDEOCONFERENCE------------------------->');
    this.enableDDBBStorage && this.getChatMessages();
    this.initializy();
    this.showModal$ = this.videoconferenceMainModalService.getModalData();
    this.lostSignalModal();
    this.changeDetectorRef.detectChanges();
  }
  /**
   * Inizializamos la videoconferencia:
   * - Se desactiva el estado intoRoomDisconnected (de la página room)
   * - Se obtienen los datos roomData de la página room
   * - Se inicializa la sessión de la videoconferencia
   * - Se obtienen los uauarios conectados
   */
  initializy() {
    typeof this.sessionStorageSrv.get('cameraButtonState') === 'boolean'
      ? this.sessionStorageSrv.get('cameraButtonState')
      : this.stateHandlerSvc.set('cameraButtonState', this.sessionStorageSrv.get('cameraButtonState'));
    typeof this.sessionStorageSrv.get('microButtonState') === 'boolean'
      ? this.sessionStorageSrv.get('microButtonState')
      : this.stateHandlerSvc.set('microButtonState', this.sessionStorageSrv.get('microButtonState'));
    this.stateHandlerSvc.set('intoRoomDisconnected', false);
    this.stateHandlerSvc.get('roomData').subscribe((response: Room) => {
      console.log(
        'VC initializy stateHandlerSvc.get(roomData) (' +
        this.utilsService.getTodayWithHour() +
        ') roomData:',
        response
      );
      this.roomData = response;
      this.initSession(response);
      this.getUserList();
      this.subscribeToTooltipSupport();
      this.changeDetectorRef.detectChanges();
    });
  }
  /**
   * Se obtiene la lista de participantes
   */
  getUserList() {
    this.subscribeToOpenUserList();

    this.participantsSvc
      .getParticipants()
      .subscribe((participants: Array<any>) => {
        console.log(
          'VC getUserList participantsSvc.getParticipants() (' +
          this.utilsService.getTodayWithHour() +
          ') participants:',
          participants
        );
        this.participantsData = null;
        this.participantsData = this.participantsSvc.getNames(participants);
        this.stateHandlerSvc.set('participants_number', participants.length);
        this.checkToForceDisconnection(participants?.length);
        this.changeDetectorRef.detectChanges();
      });
  }

  subscribeToOpenUserList() {
    this.participantsSvc.getCloseOpenUserList().subscribe((status: boolean) => {
      console.log(
        'VC subscribeToOpenUserList getCloseOpenUserList() subscribe (' +
        this.utilsService.getTodayWithHour() +
        ') status:',
        status
      );
      if (this.openChat) {
        this.openChat = false;
      }
      this.showTooltipList = status;
      this.openUsers = status;
      this.changeDetectorRef.detectChanges();
    });
  }
  /**
   * Iniciamos la sessión de Vonage
   * Se evalua si existe la sessión
   * Si hay error en el inicio de sessión se cierra la videoconferencia
   * @param roomData datos de la videocoinferencia
   */
  initSession(roomData: Room = (this.roomData as Room)) {
    this.apiTokBoxSvc
      .initSession(roomData)
      .then((session: OT.Session) => {
        console.log(
          'VC connect apiTokBoxSvc.initSession(roomData) then (' +
          this.utilsService.getTodayWithHour() +
          ') session:',
          session
        );
        this.hasSession(session);
        this.changeDetectorRef.detectChanges();
        // this.getUserList();
      })
      .catch((err) => {
        console.error(err);
        console.log(
          'Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.'
        );
        this.hungUp('');
      });
  }
  /**
   * Se evalúa si hay sessión
   * @param session datos de la sessión
   */
  hasSession(session: OT.Session) {
    this.headerSvc.setStateConection(true);
    this.sessionStorageSrv.set('statusConnection', true);
    this.session = session;
    const attendantId =
      this.activatedRoute.snapshot.queryParams[
      VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT
      ];
    console.log(
      'VC hasSession participantsSvc.setParticipants([]) (' +
      this.utilsService.getTodayWithHour() +
      ') this.streams',
      this.streams
    );
    // Necesario aunque esté solo un participante (this.streams vacío) para la creación de mensajes del chat
    if(this.roomData){
      this.participantsSvc.setParticipants([...this.streams], this.roomData);
    }
    this.sessionStorageSrv.set('session', session);
    if(this.roomData?.token){
      this.session.connect(this.roomData.token, (error) => {
        console.log(
          'VC hasSession session.connect() (' +
          this.utilsService.getTodayWithHour() +
          ') data',
          error
        );
        console.log(
          'VC hasConection session.connect() (' +
          this.utilsService.getTodayWithHour() +
          ') data',
          this.session?.connection
        );
        this.isConnect = true;
        //Se guardan los datos de la sessión
        if(this.session && this.session.connection){
          this.apiConectateServ
            .sendConection(attendantId, this.session.connection.connectionId)
            .subscribe((res) => {
              this.apiTunningService._connectionId =
                this.session?.connection?.connectionId || '';
              if(environment.isPatient && this.session.connection){
                this.apiConectateServ._connectionId = this.session.connection.connectionId;
              }
              if (
                typeof this.apiTunningService._tunningId === 'number' &&
                !this.apiTunningService._tunningSaved
              ) {
                //Se envia tunning con el connectionId ya q en mutua-network no se tiene aún
                this.apiTunningService
                  .patchTunnings({
                    connectionId: this.session?.connection?.connectionId,
                  })
                  .pipe(take(1))
                  .subscribe(() => {
                    this.apiTunningService._tunningSaved = true;
                    this.changeDetectorRef.detectChanges();
                  });
              }
              this.changeDetectorRef.detectChanges();
            });
        }
        //Si hay error al conectar a la sesión se cierra la videoconferencia
        if (error) {
          console.log(
            'VC hasSession session.connect() (' +
            this.utilsService.getTodayWithHour() +
            ') error:',
            error
          );
          this.hungUp('notFound');
        }
        this.stateHandlerSvc.set('disconnected_status', '');
      });
    }

    this.apiConectateServ.sendUserState(true);

    //Si se ha creado el stream de video del ususario
    this.session.on(this.events.SESSION_EVENTS.STREAM_CREATED, (event: any) => {
      console.log(
        'VC hasSession session.on(STREAM_CREATED) (' +
        this.utilsService.getTodayWithHour() +
        ') event:',
        event
      );
      //Se guardan los mstreams de los usuarios a medida q se crean
      this.streams.push(event.stream);

      this.features?.full_screen_two_participants &&
        this.toggleFullDeskTopPublisher();
      //Si se comparte pantalla
      if (
        event.stream.videoType === this.videoConstants.SCREEN_SHARING.SCREEN
      ) {
        this.sessionStorageSrv.set('stopSharingScreen', true);
        this.screenShareFrame = true;
        this.streamScreenShare = event.stream;
      } else {
        for (let i = 0; i < this.streams.length; i++) {
          if (this.streams[i].defaultFitMode === 'contain') {
            this.streams.splice(i, 1);
            i = this.streams.length;
          }
        }
        console.log(
          'VC hasSession session.on(STREAM_CREATED) participantsSvc.setParticipants() (' +
          this.utilsService.getTodayWithHour() +
          ') this.streams',
          this.streams
        );
        if (this.roomData){
          this.participantsSvc.setParticipants([...this.streams], this.roomData);
        }
      }
      this.changeDetectorRef.detectChanges();
    });

    //Si se destruye el stream de video de la videollamada
    this.session.on(
      this.events.SESSION_EVENTS.STREAM_DESTROYED,
      (event: any) => {
        console.log(
          'VC hasSession session.on(STREAM_DESTROYED) (' +
          this.utilsService.getTodayWithHour() +
          ') event:',
          event
        );
        console.log('Stream ' + event.stream.name + ' ended. ' + event.reason);
        // event.preventDefault();
        // Now you can adjust the DOM elements around each
        // subscriber to the stream, and then delete it yourself.
        /**
       *

      const subscribers = session.getSubscribersForStream(event.stream);

      const publisher = getPublisherForStream(event.stream);

       */
        console.log('Stream Destroyed: ?????  ', event);
        console.log(
          'Stream Desconn Data:  ' +
          event.stream.connection.id +
          ' :--: ' +
          event.stream.connection.data
        );
        if (
          event.stream.connection.connectionId ===
          this.sessionStorageSrv.get("myConnectionId")
        ) {
          this.testQualityService.resetServiceData();
        }
        /**
       *
      if (event.stream.connection.connectionId === this.sessionStorageSrv.get('myConnectionId')) {
        console.log('Trying reconnect... ');
        // this.publish();

        window.location.reload();

      } else {
       */
        const idx = this.streams.indexOf(event.stream);

        if (idx > -1) {
          this.streams.splice(idx, 1);

          if (
            event.stream.videoType !== this.videoConstants.SCREEN_SHARING.SCREEN && this.roomData
          ) {
            this.participantsSvc.setParticipants(
              [...this.streams],
              this.roomData,
              true
            );
          }

          this.changeDetectorRef.detectChanges();
        }
        // }

        //Se oculta la capa de compartir pantalla si se deja de compartir.
        if (!this.sessionStorageSrv.get('stopSharingScreen')) {
          this.screenShareFrame = false;
          this.sessionStorageSrv.set('stopSharingScreen', true);
        } else {
          this.screenShareFrame = false;
        }
        this.changeDetectorRef.detectChanges();
      }
    );
    //Si se desconecta de la sessión de la videollamada
    this.session.on(
      this.events.SESSION_EVENTS.SESSION_DISCONNECTED,
      (event: any) => {
        console.log(
          'VC hasSession session.on(SESSION_DISCONNECTED) (' +
          this.utilsService.getTodayWithHour() +
          ') event:',
          event
        );
        this.hungUp('');
        console.log('Session Disconnected: ', event);
      }
    );
    // Señal recibida de otros usuarios sobre la calidad de la banda ancha
    this.bandWithErrorModal(session);

    /**
     * Comentado para subir a PRE y evitar listernes activos
     */
    // this.session.on(this.events.SESSION_EVENTS.CONNECTION_DESTROYED, (event: any) => {
    //   // event.preventDefault();
    //   console.log('VC hasSession session.on(CONNECTION_DESTROYED) ('+this.utilsService.getTodayWithHour()+') event:', event);
    //   console.log('Connection Destroyed: ',  event);

    //   if (event?.connection?.connectionId === this.sessionStorageSrv.get('myConnectionId')) {
    //     console.log('Trying reconnect...V ');
    //     // this.publish();

    //     // window.location.reload();
    //   }
    // });
  }
  /**
   * Señal recibida de otros usuarios sobre la calidad de la banda ancha
   * @param session
   */
  bandWithErrorModal(session: OT.Session) {
    // Señal recibida de otros usuarios sobre la calidad de la banda ancha
    session.on('signal:bandwidth', (event:any) => {
      console.log('signal:bandwidth****************************', event['data']);
      if (this.bandwidthModalErrorEnable) {
        this.videoconferenceMainModalService.closeModal();
        this.videoconferenceMainModalService.setFilesOperationsData(undefined);
        this.videoconferenceMainModalService.openModal({
          title: 'Aviso de calidad de conexión',
          bodyMessage: 'Insuficiente calidad de conexión',
        });
        this.bandwidthModalErrorEnable = false;
        this.bandwidthModalErrorTimeout = setTimeout(() => {
          this.bandwidthModalErrorEnable = true;
          this.changeDetectorRef.detectChanges();
          clearTimeout(this.bandwidthModalErrorTimeout);
        }, this.bandwidthModalInterval);
      }
      this.changeDetectorRef.detectChanges();
    });
  }






  
  /**
   * Se guarda el pueblisher (Objecto de publicación del usuario)
   * @param publisher Objecto de publicación del usuario
   */
  publisherCreated(publisher: any) {
    this.publisher = publisher;
  }  /**
   * Se incluye el publisher en la sessión (stream de salida del usuario)
   */
  publish() {
    if (this.session && this.publisher) {
      this.session.publish(this.publisher, (err) => {
        console.log(
          'VC publish session.publish() (' +
          this.utilsService.getTodayWithHour() +
          ') data:',
          err
        );
        if (err) {
          console.log('error Publishing session object: ', err);
          console.log('error Publishing session: ', err.message);
        }
      });
      this.changeDetectorRef.detectChanges();
    }
  }

  /**
   * Se evaluá si es el único participante, si es así desde config.json hay una propiedad
   * que indica el teimpo en q se colgará la llamada
   * @param participantsNumber Número de participantes
   */
  checkToForceDisconnection(participantsNumber: number) {
    console.log(
      'VC checkToForceDisconnection (' +
      this.utilsService.getTodayWithHour() +
      ') participantsNumber:',
      participantsNumber
    );
    if (participantsNumber === 1) {
      this.setTimeoutId = setTimeout(() => {
        this.hungUp('');
        this.changeDetectorRef.detectChanges();
      }, this.features?.disconnection_time);
    } else {
      clearTimeout(this.setTimeoutId);
      this.changeDetectorRef.detectChanges();
    }
  }
  /**
   * Servicio de obención de mensajes guardados,
   * si la propiedad del config.json enableDDBBStorage está habilitada
   */
  getChatMessages() {
    const attendantId =
      this.activatedRoute.snapshot.queryParams[
      VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT
      ];
    this.apiChatMessagesService
      .getChatMessages(attendantId)
      .pipe(delay(100), takeUntil(this.ngUnsubscribe))
      .subscribe((messages) => {
        this.storedChatMessages = messages;
        console.log('messasges', messages);
        this.changeDetectorRef.detectChanges();
      });
  }
  /**
   * Cerramos modal de avisos/cargar archivo
   * @param data Datos del modal
   */
  closeModal(data?: Message) {
    data && this.utilsService.openFile((data.doc as string), (data.fileName as string), (data.type as string));
    this.changeDetectorRef.detectChanges();
    this.videoconferenceMainModalService.closeModal();
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Método para colgar la llamada
   * @param publisher Objeto de publicación del ususario en la videoconferencia
   */
  hungUp(publisher: any) {
    /**
     * El BehaviorSubject forceTestStopBS del testQualityService se habilita,
     * para parar el test de calidad de bandanacha antes de la redirección
     * a la sala de espera
     */
    this.testQualityService.resetServiceData();
    //Cerramos modal antes de la redirección
    this.videoconferenceMainModalService.closeModal();
    //Se elimina el estado de desconexión y luego se se asigna valor
    let disconnectedStatus: string = '';
    if (publisher === 'notFound') {
      disconnectedStatus =
        VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.NOT_FOUND;
      publisher = '';
    } else {
      disconnectedStatus =
        VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.HUNG_UP;
    }

    //Cerramos las publicaciones del publisher (stream de salida del usuario)
    if (this.publisher) {
      console.log(
        'VC hungUp session.unpublish(publisher) (' +
        this.utilsService.getTodayWithHour() +
        ')'
      );
      console.log(
        'VC hungUp publisher.off() (' +
        this.utilsService.getTodayWithHour() +
        ')'
      );
      this.session?.unpublish(publisher);
      //Destruimos el publisher de OT
      //Importante porque se queda asignado el hardware de audio y video y provoca problemas
      this.publisher.off();
      this.publisher.destroy();
    }

    clearTimeout(this.setTimeoutId);
    this.fullScreen = false;
    //Cerramos el chat antes de la redirección
    this.openChat = false;
    this.fullDesktopPublisher = false;
    console.log(
      'VC hungUp session.off() (' + this.utilsService.getTodayWithHour() + ')'
    );
    console.log(
      'VC hungUp session.disconnect() (' +
      this.utilsService.getTodayWithHour() +
      ')'
    );
    //Cerramos sessión y reseteamos valores de la videoconferencia
    this.session?.off();
    this.session?.disconnect();
    this.stateHandlerSvc.set('disconnected_status', disconnectedStatus);
    this.streams = [];
    this.participantsSvc.resetParticipants();
    this.headerSvc.setStateConection(false);
    this.tooltipSupportService.setCloseOpenTooltipSupport(false);
    this.streamScreenShare = undefined;
    this.screenShareFrame = false;
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      preserveFragment: true,
      replaceUrl: true,
    };
    //Se guarda en back el estado de cierre de la sessión del usuario
    this.apiConectateServ.sendUserState(false);
    this.changeDetectorRef.detectChanges();
    //Se detiene la grabación si está activa
    this.stateHandlerSvc.get('record_state').subscribe((data: any) => {
      console.log(
        'VC hungUp record_state (' +
        this.utilsService.getTodayWithHour() +
        '): data',
        data
      );
      if (data?.state) {
        console.log(
          'VC hungUp apiTokBoxSvc.StopRecord (' +
          this.utilsService.getTodayWithHour() +
          ')'
        );
        this.apiTokBoxSvc.StopRecord(data?.id).subscribe();
      }
      console.log(
        'VC navigate to ROOM!!! (' + this.utilsService.getTodayWithHour() + ')'
      );
      this.changeDetectorRef.detectChanges();
      this.router.navigate([ROUTES_CONSTANTS.ROOM.path], navigationExtras);
    });
    if(environment.isPatient){
      this.stateHandlerSvc.set('goToSurvey', true);
    }
    this.changeDetectorRef.detectChanges();
  }

  toggleFullScreen(ev: any) {
    this.fullScreen = ev;
    this.changeDetectorRef.detectChanges();
  }

  toggleFullDeskTopPublisher() {
    this.fullDesktopPublisher = !this.fullDesktopPublisher;
    this.changeDetectorRef.detectChanges();
    this.participantsSvc
      .getParticipants()
      .subscribe((participants$: Array<any>) => {
        // TODO: CONSULTAR SI ESTA CONDICION AUN ES NECESARIA Y SI ES ASI, PARA QUE SIRVE.
        if (participants$.length > this.MAX_PARTICIPANTS_COMPLETESCREEN) {
          this.fullDesktopPublisher = false;
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  toggleFullScreenPublisher() {
    this.fullScreenPublisher = !this.fullScreenPublisher;
    this.changeDetectorRef.detectChanges();
  }

  toggleSubscriberAudio(ev: any) {
    this.subscriberAudio = ev;
    this.changeDetectorRef.detectChanges();
  }
  /**
   * Abrir y cerrar chat
   */
  toggleChat() {
    if (this.showTooltipList) {
      this.participantsSvc.setCloseOpenUserList(false);
    }

    this.openChat = !this.openChat;
    !this.openChat && this.videoconferenceMainModalService.closeModal();
    this.chatMessages = this.openChat ? !this.openChat : false;
    this.changeDetectorRef.detectChanges();
  }
  /**
   * Mensajes recibidos
   * @param msg
   */
  messagesRecieved(msg: any) {
    this.chatMessages = !this.openChat && msg ? msg : false;
    this.changeDetectorRef.detectChanges();
  }

  toggleShareFrame() {
    this.screenShareFrame = !this.screenShareFrame;
    this.changeDetectorRef.detectChanges();
  }

  lostSignalModal() {
    const lostSignal = !!localStorage.getItem('lostSignalRedirect');
    if (lostSignal) {
      localStorage.removeItem('lostSignalRedirect');
      this.closeModalLostSignal();
      this.changeDetectorRef.detectChanges();
    }
    this.showLostSignalModal$ = this.testQualityService.getshowLostSignalModalBS$().pipe(tap((arg) => {
      console.log('lostSignalModal', arg);
      this.changeDetectorRef.detectChanges();
    }));
  }

  /**
   * Abrir modal por pérdida de conexión, redirección al test
   * @param session
   */
  closeModalLostSignal() {
    document.location.href = document.location.protocol + "//" + document.location.host + '/' + document.location.search;
  }

  ngOnDestroy(): void {
    clearTimeout(this.bandwidthModalErrorTimeout);
    this.testQualityService.showLostSignalModalBS.next(false);
    this.changeDetectorRef.detectChanges();
  }

  subscribeToTooltipSupport() {
    this.openCloseTooltipSupport$ = this.tooltipSupportService.getCloseOpenTooltipSupport();
    this.changeDetectorRef.detectChanges();
  }

}
